import {
  START_FILE_EDIT,
  STOP_FILE_EDIT,
  STOP_ALL_FILE_EDITS,
  UiEditingActions,
} from 'src/action-types/uiEditing/action-types';

export type UiEditingState = { editingIds: number[] };
const initialState: UiEditingState = { editingIds: [] };

export default function uiEditing(
  state: UiEditingState = initialState,
  action: UiEditingActions
): UiEditingState {
  switch (action.type) {
    case START_FILE_EDIT: {
      const id = action.payload;
      if (state.editingIds.includes(id)) return state;
      const next = { editingIds: [...state.editingIds, id] };
      return next;
    }
    case STOP_FILE_EDIT: {
      const id = action.payload;
      const next = { editingIds: state.editingIds.filter(x => x !== id) };
      return next;
    }
    case STOP_ALL_FILE_EDITS: {
      return { editingIds: [] };
    }
    default:
      return state;
  }
}
